import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/family/{family_account_id}/auto_refill_data
export const autoRefillData = async (familyAccountId: number) => {
  const response = await new Request().get('/ajax/family/' + familyAccountId + '/auto_refill_data')
  return Util.Obj.keysToCamel(response.data.refill_data)
}
